import ipfsLink from "./ipfsLink";

async function verifyMetadata(NFT) {
  if (!NFT) return NFT;
  if (NFT.metadata && NFT.metadata !== "") return NFT;
  //Validate URI
  if (!NFT.tokenUri || !NFT.tokenUri.includes("://")) {
    console.log("getMetadata() Invalid URI", { URI: NFT.tokenUri, NFT });
    return NFT;
  }
  //Get Metadata
  try {
    const res = await fetch(ipfsLink(NFT.tokenUri));
    const metadata = await res.json();
    if (metadata) {
      if (
        metadata?.detail &&
        metadata.detail.includes("Request was throttled")
      ) {
        //Handle Setbacks
        //Log
        console.log("verifyMetadata.js - Request was throttled");
      } else {
        //Add Metadata
        NFT.metadata = metadata;
        //Set the Name
        if (metadata && metadata?.name) NFT.name = metadata?.name;
        //Set the Description
        if (metadata && metadata?.description)
          NFT.description = metadata?.description;
      }
    }
  } catch (error) {
    console.log(error);
  }
  return NFT;
}

export default verifyMetadata;
